<template>
  <div>
    <v-app id="app" style="margin-top: 1rem">
      <v-navigation-drawer v-model="drawer" app clipped disable-resize-watcher>
        <v-list dense>
          <!-- Home-->
          <v-list-item class="mt-4" link v-on:click="goto('/home')">
            <v-list-item-action>
              <v-icon color="white darken-1">mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-title class="white--text text--darken-1"
              >Home</v-list-item-title
            >
          </v-list-item>
          <!-- Home-->
          <v-list-item class="mt-4" link v-on:click="goto('/listaAc')">
            <v-list-item-action>
              <v-icon color="white darken-1">mdi-format-list-bulleted</v-icon>
            </v-list-item-action>
            <v-list-item-title class="white--text text--darken-1"
              >Vie</v-list-item-title
            >
          </v-list-item>
          <!-- anagrafe-->
          <v-list-item link v-on:click="goto('/anagrafe')">
            <v-list-item-action>
              <v-icon color="white darken-1">mdi-account-supervisor</v-icon>
            </v-list-item-action>
            <v-list-item-title class="white--text text--darken-1"
              >Anagrafe</v-list-item-title
            >
          </v-list-item>
          <!-- stampe-->
          <v-list-item class="mt-4" link v-on:click="goto('/stampe')">
            <v-list-item-action>
              <v-icon color="white darken-1">mdi-printer-wireless</v-icon>
            </v-list-item-action>
            <v-list-item-title class="white--text text--darken-1"
              >Stampe</v-list-item-title
            >
          </v-list-item>
          <v-spacer />
          <v-divider />
        </v-list>
       
        <v-list>
          
          <v-list-item link v-on:click="goto('/login')">
            <v-list-item-action>
              <v-icon color="white darken-1">mdi-account-plus</v-icon>
            </v-list-item-action>
            <v-list-item-title class="white--text text--darken-1"
              >Login</v-list-item-title
            >
          </v-list-item>
          <v-list-item link v-on:click="logout()">
            <v-list-item-action>
              <v-icon color="white darken-1">mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-title class="white--text text--darken-1"
              >Logout</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar app clipped-left="" color="red" dense>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        </v-app-bar-nav-icon>

        <v-toolbar-title class="toolbarTitolo pr-0 pl-0 mr-0 ml-0 align-center">
          <div class="titoloEdit">
            <span class="title">{{ titolo }}</span>
          </div>
        </v-toolbar-title>
        <v-spacer />
        <div class="comuneCorrente">{{ currentComune }}</div>
        <v-btn
          class="nickNameBtn"
          v-show="loggedIn && !isLoginPage"
          exact=""
          small
          outlined=""
          right=""
          @click="userDialog = true"
          >{{ userId }}
        </v-btn>
        <v-dialog v-model="userDialog" max-width="390">
          <v-card>
            <v-card-title class="text-h5"> Info account </v-card-title>

            <v-card-text> Sei loggato come {{ userId }} </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" text v-on:click="logout()">
                LOGOUT
              </v-btn>

              <v-btn color="green darken-1" text @click="userDialog = false">
                Annulla
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <v-icon
          v-show="!loggedIn && !isLoginPage"
          @click="userDialog = true"
          dense=""
          >mdi-account</v-icon
        >

        <router-link
          class="login"
          v-show="!loggedIn && !isLoginPage"
          to="/login"
          >Login</router-link
        >
      </v-app-bar>

      <transition name="page-transition" mode="out-in">
        <keep-alive >
        <router-view class="view"></router-view>
        </keep-alive>
      </transition>
    </v-app>
  </div>
</template>
    <script>
import { router } from "./main.js";
import { userService } from "./services/userServices.js";
export default {
  data() {
    return {
      titolo: "?",
      
      
      loggedIn: false,
      isLoginPage: false,
      userId: "",
      drawer: false,
      currentComune: "",
      userDialog: false,
    };
  },
  mounted() {
    
  },
  watch: {
    $route(to, from) {// eslint-disable-line no-unused-vars
      this.currentComune = userService.getCurrentComune();

      document.title = to.meta.title;
      this.titolo = to.meta.title;

      if (to.name == "login") {
        this.isLoginPage = true;
      } else {
        this.isLoginPage = false;
      }
      //gestione logged
      this.userBox();
    },
  },
  methods: {
    userBox() {
      this.userId = userService.getUserInfo().userId;
      if (this.userId) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    },
    logout() {
      this.drawer= false;
      this.userDialog = false;
      this.loggedIn=false;
      userService.logout();
      router.push("/home");
      
    },
    clickOnTitoloLista() {
      this.allowEditTitolo = true;
      const input = document.querySelector(".titoloLista input");
      input.select();
    },
    changeTitolo() {
      this.allowEditTitolo = false;

      userService.updateListTitle(this.titolo);
    },
    goto(t) {
      
      router.push(t);
      this.drawer= false;
    },
    gestioneLista() {
      //alert("gestione lista");
    },
  },
};
</script>
<style>
.backIcon{
  margin-left: 12px;
 border-radius:8px;
 padding:0.6rem;
 border:2px solid grey;
 font-weight:800;
 position:absolute;
 top:2.3rem;
  left: 0.00rem;


}
.button.nickNameBtn {
  border: 0px solid red;
  margin-right: -0.5rem;
  text-transform: lowercase;
}
a.login:link,
a.login:visited {
  color: white;
  font-size: 0.9rem;
  font-weight: 400;
}
.toolbarTitolo input {
  font-size: 0.9rem;
}
.page-transition-enter-active,
.page-transition-leave-active {
  transition-duration: 3.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.page-transition-enter,
.page-transition-leave-active {
  opacity: 0;
}
.comuneCorrente {
  font-size: 0.9rem;
  font-weight: 400;
   margin-right: 0.8rem;
}
h3{
color:cyan;
}
fieldset legend{
color:cyan;
} 
legend{
  font-weight: bold;
  
  padding-left: 1rem;
  padding-right: 1rem;
}
h4 label{
  letter-spacing: 1px;
  font-size: 11pt;
  color: blue;
  font-weight: 600;
}
p.label.h3{
   color:cyan;
  font-size: 1.2rem;
  font-weight: bold;
  float: left;
}
p.label.h4{
   text-rendering: optimizelegibility;
  line-height: 24px;
   _letter-spacing: 1px;
  font-size: 14px;
  color: rgb(255, 255, 255);
  font-weight: 600;
  margin: 0;
  padding: 0;

}
tr.higlightRow:hover{
  
  background-color:	 #4d4d4d;
}
</style>